<template>
 <div>
   <h3 class="luci-subtitle pr-4 pt-4 pl-4">
     Welcome
     <span
       v-if="profile && profile.name"
       class="font-weight-bold"
     >{{ profile.name }}</span>
   </h3>

   <p v-if="authenticated" class="luci-text pr-4 pl-4">You can now configure all things related to <strong>games</strong> using this manager.</p>
   <p v-else class="luci-text pr-4 pl-4">Please login to use Games Manager.</p>
 </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Home',
  computed: mapGetters('auth', ['authenticated', 'profile'])
}
</script>
